import { TW_DecimalFilterValueEditor, TW_DecimalFilterValueEditor_editing, TW_DecimalFilterValueEditor_Wrapper } from "@utils/twClasses";
import { displayCurrency } from "@utils/types";
import { useEffect, useState } from "react";
import { AbstractValueEditor } from "./AbstractValueEditor";


type CurrencyValueEditorProps = {
    format: Map<string, any> | undefined;
    value: any;
    disabled: boolean;
    onValueChange: (value: any) => void;
}

export function CurrencyValueEditor({ format, value, disabled, onValueChange }: CurrencyValueEditorProps) {

    const [text, setText] = useState(value || "");
    const [editing, setEditing] = useState(false);

    const currencyRegex = /^-?\d*\.?\d*$/;

    useEffect(() => {
        setText(value || "");
    }, [value]);

    const textToValue = (text: string | null): any => {
        if (!text || text.length === 0) {
            return null;
        }
        if (text === "-") {
            return 0;
        }
        return parseFloat(text);
    }

    const valueToText = (): string => {
        if (!value) {
            return "";
        }

        return displayCurrency(value, format);
    }

    function isTextValid(value: string | null) {
        if (!value || value.length === 0) {
            return true;
        }
        return currencyRegex.test(value);
    }

    const renderReadOnlyContent = () => {
        return (
            <div className={TW_DecimalFilterValueEditor_Wrapper} onClick={() => setEditing(true)}>
                <div className={TW_DecimalFilterValueEditor}>
                    {valueToText()}
                </div>
            </div>)
    }

    const renderEditingContent = (
        onBlur: () => void,
        onEnterKeyPress: (event: React.KeyboardEvent) => void,
        onTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void) => {
        return (<div className={TW_DecimalFilterValueEditor_Wrapper}>
            <input
                className={TW_DecimalFilterValueEditor_editing}
                type="text"
                value={text}
                onBlur={onBlur}
                onKeyDown={onEnterKeyPress}
                onChange={onTextChange}
                disabled={disabled}
                autoFocus />
        </div>)
    }

    return <AbstractValueEditor
        initialValue={value}
        editing={editing}
        renderReadOnlyContent={renderReadOnlyContent}
        renderEditingContent={renderEditingContent}
        textToValue={textToValue}
        isTextValid={isTextValid}
        getText={() => text}
        setText={setText}
        setEditing={setEditing}
        onValueChange={onValueChange} />
}